// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import NumbersSvg from '@rsuite/icon-font/lib/charts/Numbers';
var Numbers = createSvgIcon({
  as: NumbersSvg,
  ariaLabel: 'numbers',
  category: 'charts',
  displayName: 'Numbers'
});
export default Numbers;